import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap"
}
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = { class: "playbook" }
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap","margin-top":"15px"}
}
const _hoisted_6 = {
  key: 1,
  style: {"margin":"15px 0","font-size":"20px","color":"red"}
}
const _hoisted_7 = {
  key: 2,
  class: "item-form-tabs",
  style: {"margin-top":"20px"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 3,
  style: {"font-weight":"bold"}
}
const _hoisted_10 = {
  key: 4,
  style: {"color":"green","font-weight":"bold"}
}
const _hoisted_11 = { key: 5 }
const _hoisted_12 = {
  key: 6,
  style: {"margin-top":"15px"}
}
const _hoisted_13 = {
  id: "playbook-sheet-wrap",
  class: "playbook-sheet-wrap company-sheet-wrap"
}
const _hoisted_14 = ["onContextmenu"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  style: {"font-size":"16px"}
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "form-close" }
const _hoisted_23 = { class: "checkbox-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_select_employees = _resolveComponent("select-employees")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-bar-sub" }, "Work", -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.debounceSubmit())),
                style: {"background":"none","border":"none","padding":"0","color":"white","font-size":"24px","font-weight":"bold","margin":"0","height":"auto","width":"auto","field-sizing":"content","min-inline-size":"20px"}
              }, null, 544), [
                [_vModelText, _ctx.name]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.$store.state.user.role == 'Admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editUsers())),
                    class: "add-btn",
                    style: {"margin-right":"10px"}
                  }, "Edit Users")
                ]))
              : _createCommentVNode("", true),
            (_ctx.isTemplate && _ctx.$store.state.user.companyID == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("b", null, "TEMPLATE - DO NOT EDIT", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.companyScorecard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(month.selected ? 'item-tab-selected' : ''),
                      onClick: ($event: any) => (_ctx.companyScorecardMonthChange(month))
                    }, _toDisplayString(month.name), 11, _hoisted_8))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Saving..."))
              : (_ctx.saved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "All Changes Saved."))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, " ")),
            (_ctx.colsToHide.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => { _ctx.colsToHide = [] }, ["prevent"]))
                  }, "Show All Cols")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", {
                id: "playbook-sheet",
                class: _normalizeClass(_ctx.companyScorecard ? 'playbook-sheet scorecard-playbook-sheet' : 'playbook-sheet')
              }, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheetJSON.rows, (row, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'r'+i
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
                        return _withDirectives((_openBlock(), _createElementBlock("td", {
                          style: _normalizeStyle((_ctx.companyScorecard && j == 58 && i != 0) ? 'background:'+col.text : ''),
                          key: 'c'+j,
                          onContextmenu: ($event: any) => (_ctx.cellRightClick($event, i, j))
                        }, [
                          (_ctx.companyScorecard && j == 58 && i != 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("select", {
                                  style: {"width":"90px","font-weight":"bold","margin":"0"},
                                  "onUpdate:modelValue": ($event: any) => ((col.text) = $event),
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.debounceSubmit()))
                                }, [...(_cache[25] || (_cache[25] = [
                                  _createElementVNode("option", { value: "Green" }, "Green", -1),
                                  _createElementVNode("option", { value: "Yellow" }, "Yellow", -1),
                                  _createElementVNode("option", { value: "Red" }, "Red", -1)
                                ]))], 40, _hoisted_16), [
                                  [_vModelSelect, col.text]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                (col.calculatedValue)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(col.calculatedValue), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        style: _normalizeStyle(col.bold ? 'font-weight:bold' : ''),
                                        "onUpdate:modelValue": ($event: any) => ((col.text) = $event),
                                        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.debounceSubmit()))
                                      }, null, 44, _hoisted_20), [
                                        [_vModelText, col.text]
                                      ])
                                    ])),
                                (col.secondLine)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(col.secondLine), 1))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 44, _hoisted_14)), [
                          [_vShow, !_ctx.colsToHide.includes(j)]
                        ])
                      }), 128))
                    ]))
                  }), 128))
                ])
              ], 2)
            ])
          ])
        ], 2),
        (_ctx.showRightClickMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "form-wrapper link-pop",
              style: _normalizeStyle(`top: ${_ctx.rightClickY - 20}px; left: ${_ctx.rightClickX}px`)
            }, [
              _createElementVNode("span", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  class: "form-close-x",
                  title: "Close",
                  onClick: _cache[6] || (_cache[6] = () => { _ctx.showRightClickMenu = false })
                }, "×")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.hideCol(_ctx.rightClickCellCol)), ["prevent"]))
                }, "Hide Col")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.addRow(_ctx.rightClickCellRow)), ["prevent"]))
                }, "Add Row Above")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.addRow(_ctx.rightClickCellRow + 1)), ["prevent"]))
                }, "Add Row Below")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.addCol(_ctx.rightClickCellCol)), ["prevent"]))
                }, "Add Col Left")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.addCol(_ctx.rightClickCellCol + 1)), ["prevent"]))
                }, "Add Col Right")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.removeRow(_ctx.rightClickCellRow)), ["prevent"]))
                }, "Delete Row")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.removeCol(_ctx.rightClickCellCol)), ["prevent"]))
                }, "Delete Col")
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  style: {"margin":"0"},
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.debounceSubmit())),
                  type: "text",
                  placeholder: "Second Line",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].secondLine) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].secondLine]
                ])
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  style: {"margin":"0 0 5px"},
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.debounceSubmit())),
                  type: "text",
                  placeholder: "Function",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].function) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].function]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.debounceSubmit())),
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].bold) = $event))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.sheetJSON.rows[_ctx.rightClickCellRow][_ctx.rightClickCellCol].bold]
                ]),
                _cache[26] || (_cache[26] = _createTextVNode(" Bold ", -1))
              ])
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.showConfirmColRemove)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 1,
              onConfirm: _ctx.removeColCB,
              onCancel: _cache[20] || (_cache[20] = () => { _ctx.showConfirmColRemove = false; }),
              msg: "Are you sure you would like to delete this col?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showConfirmRowRemove)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 2,
              onConfirm: _ctx.removeRowCB,
              onCancel: _cache[21] || (_cache[21] = () => { _ctx.showConfirmRowRemove = false; }),
              msg: "Are you sure you would like to delete this row?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showEditUsers)
          ? (_openBlock(), _createBlock(_component_select_employees, {
              key: 3,
              title: "Share with",
              source: "/api/employees/picker",
              selectedIds: _ctx.editUsersCurrent,
              onSave: _ctx.saveUsers,
              onClose: _cache[22] || (_cache[22] = () => { _ctx.showEditUsers = false; })
            }, null, 8, ["selectedIds", "onSave"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}